import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { onboardingServices } from "../../services/onboardingServices";
import { adminServices } from "../../services/adminServices";
import { isEmptyDash } from "../../constant";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";


function DigitalSignature(props) {
  const { id } = useParams();
  const [digitalSignature, setSignatureImage] = useState(null);
  const [digitalStamp, setStampImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertComponent({ ...alertComponent, open: false });
  };
  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };

  useEffect(() => {
    if (isEmptyDash(props?.profileData?.digitalSignature)) {
      setSignatureImage(null);
    } else {
      setSignatureImage(props?.profileData?.digitalSignature);
    }

    if (isEmptyDash(props?.profileData?.digitalStamp)) {
      setStampImage(null);
    } else {
      setStampImage(props?.profileData?.digitalStamp);
    }
  }, [props?.profileData]);

  const handleRemoveImage = (param, secName) => {
    let bodyData = { [param]: "" };
    updateImg(bodyData, "", secName);
  };

  const handleReplaceImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleUpload(file, e.target.name);
    }
  };

  const handleUpload = (uploadFile, secName) => {
    let formData = new FormData();
    formData.append("file", uploadFile);

    setIsLoading(true);
    onboardingServices
      .uploadFile(formData)
      .then(function (response) {
        const uploadKey = response?.data?.data?.data?.key;
        if (uploadKey) {
          let bodyData = { [secName]: uploadKey };
          updateImg(bodyData, uploadFile, secName);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", error);
        setIsLoading(false);
      });

  };

  const updateImg = (bodyData, file, secName) => {
    setIsLoading(true);
    adminServices
      .uploadFile(bodyData, id)
      .then(function (response) {
        if (response?.data?.success === true) {
          if (secName == "digitalSignature") {
            const imageUrl = URL.createObjectURL(file);
            setSignatureImage(imageUrl);
          }

          if (secName == "digitalStamp") {
            const imageUrl = URL.createObjectURL(file);
            setStampImage(imageUrl);
          }

          if (secName == "removeSign") {
            setSignatureImage(null);
            document.getElementById("input-signature-id").value = null;
          }

          if (secName == "removeStamp") {
            setStampImage(null);
            document.getElementById("input-stamp-id").value = null;
          }

          openAlert(true, "success", `${response?.data?.message}`);
          // setLastModified(`${response?.data?.updatedAt}`);
          // window.location.reload();
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div className="lets_head_purchase_vendor_profileies">
            <div className="main_row_detail_lr_react_1">
              <div className="lets_react_order_listing_level_profile">
                <div className="content_react_level_details">
                  <p className="lets_block_react_details_purchaseprofile">
                    Digital Signature and Stamp
                  </p>
                </div>
              </div>
              <div className="main_row_vendor_profile_signature">
                <div className="box1_vendor_profile1">
                  <p>Digital Signature</p>
                  <div className="block_index_vendor_profile0s">
                    {!isEmptyDash(digitalSignature) ? (
                      <img src={digitalSignature} alt="Digital Signature" />
                    ) : (
                      <p className="avaialble_mas">No image available</p>
                    )}
                  </div>
                  {(!isEmptyDash(digitalSignature)) && <div className="vendor_id_buttons">
                    <button type="button" className="btn btn-secondary" onClick={() => handleRemoveImage("digitalSignature", "removeSign")}>Remove</button>
                    <label className="btn btn-success">
                      Replace Image
                      <input type="file" name="digitalSignature" accept=".png, .jpg, .jpeg" id="input-signature-id" style={{ display: 'none' }} onChange={handleReplaceImage} />
                    </label>
                  </div>}

                  {(isEmptyDash(digitalSignature)) && <div style={{ marginTop: "10px" }}>
                    <label className="btn btn-success">
                      Upload
                      <input type="file" name="digitalSignature" accept=".png, .jpg, .jpeg" id="input-signature-id" style={{ display: 'none' }} onChange={handleReplaceImage} />
                    </label>
                  </div>}
                </div>
                <div className="box1_vendor_profile1">
                  <p>Digital Stamp</p>
                  <div className="block_index_vendor_profile0s" style={{ display: 'flex', justifyContent: 'center' }}>
                    {!isEmptyDash(digitalStamp) ? (
                      <img src={digitalStamp} alt="Digital Stamp" style={{ maxWidth: '100%' }} />
                    ) : (
                      <p className="avaialble_mas">No image available</p>
                    )}
                  </div>
                  {(!isEmptyDash(digitalStamp)) && <div className="vendor_id_buttons">
                    <button type="button" className="btn btn-secondary" onClick={() => handleRemoveImage("digitalStamp", "removeStamp")}>
                      Remove
                    </button>
                    <label className="btn btn-success">
                      Replace Image
                      <input type="file" name="digitalStamp" accept=".png, .jpg, .jpeg" id="input-stamp-id" style={{ display: 'none' }} onChange={handleReplaceImage} />
                    </label>
                  </div>}

                  {(isEmptyDash(digitalStamp)) && <div style={{ marginTop: "10px" }}>

                    <label className="btn btn-success">
                      Upload
                      <input type="file" name="digitalStamp" accept=".png, .jpg, .jpeg" id="input-stamp-id" style={{ display: 'none' }} onChange={handleReplaceImage} />
                    </label>
                  </div>}
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => 99999,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  )
}

export default DigitalSignature